module.exports = __webpack_public_path__ + "img/platform-channel.946b9fd1.png";